module.exports = __webpack_public_path__ + "5d87577b8e4113dad7cbdb2366d61914.png";